/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
export function Descriptions() {

    return(
        <div>
        <div className="flex flex-col md:flex-row items-center">
            <div>
                <h1 className='font-bold text-xl md:text-3xl py-2 dark:text-white'>Welcome to Indeep<sup>Net</sup></h1>
                <p className='font-normal text-sm md:text-base text-justify py-2 md:mr-10 dark:text-white'>
                InDeep represents a paradigm shift in the realm of protein-protein interaction (PPI) drug discovery 
                by integrating state-of-the-art deep learning frameworks with rigorously curated datasets to accurately 
                identify functional and ligandable binding sites critical for therapeutic targeting. By analyzing both 
                static experimental structures and dynamic molecular trajectories, InDeep achieves an unprecedented 
                resolution of binding site characterization, surpassing traditional methodologies in precision and 
                robustness. This tool provides comprehensive insights into epitope binding profiles, ligandability 
                metrics, and spatiotemporal conformational changes, facilitating the rational design of small molecules 
                or biologics targeting PPIs. Accessible through the intuitive InDeep<sup>net</sup> platform, this technology empowers 
                medicinal chemists and structural biologists with actionable predictions, streamlining the drug design 
                process and enabling the development of novel therapies for diseases driven by aberrant PPIs.
                </p>
            </div>
            <div>
                <img alt='schema' name='indeep schema' className="h-auto max-w-xs" src='indeep_schema.png'></img>
            </div>
        </div>
        <div className="flex flex-col md:flex-row items-center">
        <a href="/about"
          className="mb-2 select-none rounded font-roboto bg-amber-500 hover:bg-amber-600 py-2 px-4 text-center align-middle text-xs font-bold uppercase text-white shadow-md dark:shadow-orange-600/20 shadow-orange-800/20 transition-all hover:shadow-lg dark:hover:shadow-orange-600/40 hover:shadow-orange-800/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none peer-placeholder-shown:pointer-events-none peer-placeholder-shown:bg-gray-500 peer-placeholder-shown:opacity-50 peer-placeholder-shown:shadow-none"
          
        >
          READ MORE
      </a>
        </div>
        </div>
    )
}